import { convertDateTimeToDateString } from "./datetimeUtils";

export function toNullIfEmptyOrZero(value) {
    if (value === "" || Number(value) === 0) {
        return null;
    }
    return value;
}

export function handlePriceWithRM(price) {
    if (price == null) {
        return "";
    }
    else if (price < 0) {
        return "- RM " + Math.abs(price);
    }
    return "RM " + Math.abs(price);
}

export function handlePriceWithDate(price, date) {
    if (price == null || price === 0) {
        return "";
    }
    return (
        <>
            {handlePriceWithRM(price)}
            {" "}
            <span className="text-muted" style={{ fontSize: "0.85em" }}>
                ({convertDateTimeToDateString(date)})
            </span>
        </>
    );
}

export function handleFormatPriceString(priceString) {
    const formattedPrice = new Intl.NumberFormat("en-MY", {
        style: "currency",
        currency: "MYR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(priceString);

    return formattedPrice;
}